import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {fetchArticle} from './../actions';

class ArticleContainer extends React.Component {
  constructor(props) {
    super(props);

    this.fetchIfNeeded = this.fetchIfNeeded.bind(this);
  }

  componentDidMount() {
    this.fetchIfNeeded(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchIfNeeded(nextProps);
  }

  fetchIfNeeded(props) {
    const {params, article, fetchArticle} = props;
    if (params.articleId && (params.articleId !== article.item.id)) {
      if (!article.isFetching) {
        fetchArticle(params.articleId);
      }
    }
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

ArticleContainer.propTypes = {
  children: React.PropTypes.node,
  params: React.PropTypes.object,
  article: React.PropTypes.object.isRequired,
  fetchArticle: React.PropTypes.func.isRequired
};


function mapStateToProps(state) {
  const {article} = state;
  return {
    article
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchArticle: bindActionCreators(fetchArticle, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/articles/containers/ArticleContainer.js
 **/